import { CanMatchFn } from '@angular/router';

/**
 * Known route segments that must never be treated as a clientId.
 * If the first URL segment matches any of these, the /:clientId route
 * is skipped and Angular falls through to the 404 wildcard.
 */
const KNOWN_ROUTE_SEGMENTS = new Set([
  'login',
  'auth',
  'forgot-password',
  'reset-password',
  'reset-success',
  'forgot-success',
  'register',
  'invalid-invitation',
  'access-denied',
  'dashboard',
  'admin-settings',
  'campaigns',
  'members',
  'incentives',
  'segmentation',
  'analytics',
  'not-found'
]);

/**
 * Prevents known route segment names (e.g. /login, /dashboard) from being
 * matched as a /:clientId. Without this guard, Angular would greedily bind
 * any first URL segment to :clientId, so /login would become clientId=login.
 */
export const clientIdGuard: CanMatchFn = (_route, segments) => {
  const firstSegment = segments[0]?.path?.toLowerCase();
  return !!firstSegment && !KNOWN_ROUTE_SEGMENTS.has(firstSegment);
};
